module.exports = require("nedb");